// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre[data-v-79996b7f] {\n  white-space: pre;\n}\n.home-content-wrap[data-v-79996b7f] {\n  max-width: 1100px;\n}\n", ""]);
// Exports
module.exports = exports;
